import React from 'react'

import { Breakpoints, BreakpointIdentifier } from '@emico/styles'

export interface CurrentBreakpoint {
  breakpoints: Breakpoints
  currentBreakpoint: keyof typeof BreakpointIdentifier
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
  isPortrait: boolean
}

const CurrentBreakpointContext = React.createContext<
  CurrentBreakpoint | undefined
>(undefined)

export default CurrentBreakpointContext
